module.exports = __webpack_public_path__ + "img/arrow-right-white.eea7a105.svg";